import './App.css';
import { Routes, Route } from 'react-router-dom';
import Landing from './components/Landing';
import Home from './components/Home';
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import Frontend from './components/Roadmaps/Frontend.js';
import Backend from './components/Roadmaps/Backend';
import Android from './components/Roadmaps/Android';
import ML from './components/Roadmaps/ML';
import GameDev from './components/Roadmaps/GameDev';
import Profile from './components/Profile';
import { db } from './firebase';
import { setDoc, doc, getDoc } from "firebase/firestore";
import { useUserAuth } from './context/UserAuthContext';
import { useEffect, useState } from 'react';
import Footer from './components/UI/Footer';
import Contact from './components/Contact';
import GoToTop from './components/GoToTop';

function App() {
  const { currentUser, onAuthStateChanged } = useUserAuth();

  // Saving the progress data

  const saveFrontendProgressData = async (data) => {

    try {
      if (currentUser) {
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};
        
        userData.id = currentUser.email;
        userData.frontendData = data;

        await setDoc(userRef, userData);

        console.log(`Frontend development progress data for user ${currentUser.email} updated successfully`);
      }
      else {
        console.log('User Not Logged In No Data Saved!');
      }
    } catch (e) {
      console.error("Error adding document: ", e);
    }

  }

  const saveBackendProgressData = async (data) => {

    try {
      if (currentUser) {
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};

        userData.id = currentUser.email;
        userData.backendData = data;

        await setDoc(userRef, userData);

        console.log(`Backend development progress data for user ${currentUser.email} updated successfully`);
      }
      else {
        console.log('User Not Logged In No Data Saved!');
      }
    } catch (e) {
      console.error("Error adding document: ", e);
    }

  }

  const saveAndroidProgressData = async (data) => {

    try {
      if (currentUser) {
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};

        userData.id = currentUser.email;
        userData.androidData = data;

        await setDoc(userRef, userData);

        console.log(`Android development progress data for user ${currentUser.email} updated successfully`);
      }
      else {
        console.log('User Not Logged In No Data Saved!');
      }
    } catch (e) {
      console.error("Error adding document: ", e);
    }

  }

  const saveMLProgressData = async (data) => {

    try {
      if (currentUser) {
        // 
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};

        userData.id = currentUser.email;
        userData.MLData = data;

        await setDoc(userRef, userData);

        console.log(`Machine Learning progress data for user ${currentUser.email} updated successfully`);
      }
      else {
        console.log('User Not Logged In No Data Saved!');
      }
    } catch (e) {
      console.error("Error adding document: ", e);
    }

  }

  const saveGameDevProgressData = async (data) => {

    try {
      if (currentUser) {

        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};

        userData.id = currentUser.email;
        userData.gameDevData = data;

        await setDoc(userRef, userData);

        console.log(`Game development progress data for user ${currentUser.email} updated successfully`);
      }
      else {
        console.log('User Not Logged In No Data Saved!');
      }
    } catch (e) {
      console.error("Error adding document: ", e);
    }

  }

  //const [authChecked, setAuthChecked] = useState(false);

  //Getting Progress Data
  const handleFrontendProgressData = async () => {
    try {
      if (currentUser) {
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};
        console.log("userData:", userData);

        const frontendData = userData.frontendData;
        console.log("frontendData:", frontendData);
        return frontendData;
      } else {
        console.error("User not logged in");
        return null;
      }
    } catch (e) {
      console.error("Error getting document: ", e);
      return null;
    }
  };


  const handleBackendProgressData = async () => {
    try {
      if (currentUser) {
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};

        const backendData = userData.backendData;

        return backendData;
      } else {
        console.error("User not logged in");
        return null;
      }
    } catch (e) {
      console.error("Error getting document: ", e);
      return null;
    }
  }

  const handleAndroidProgressData = async () => {
    try {
      if (currentUser) {
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};

        const androidData = userData.androidData;

        return androidData;
      } else {
        console.error("User not logged in");
        return null;
      }
    } catch (e) {
      console.error("Error getting document: ", e);
      return null;
    }
  }

  const handleMLProgressData = async () => {
    try {
      if (currentUser) {
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};

        const MLData = userData.MLData;

        return MLData;
      } else {
        console.error("User not logged in");
        return null;
      }
    } catch (e) {
      console.error("Error getting document: ", e);
      return null;
    }
  }

  const handleGameDevProgressData = async () => {
    try {
      if (currentUser) {
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};

        const gameDevData = userData.gameDevData;

        return gameDevData;
      } else {
        console.error("User not logged in");
        return null;
      }
    } catch (e) {
      console.error("Error getting document: ", e);
      return null;
    }
  }

  const handleTotalProgressData = async() =>{
    try {
      if (currentUser) {
        const userRef = doc(db, "roadmaps", currentUser.email);

        const userSnapshot = await getDoc(userRef);
        const userData = userSnapshot.data() || {};

        return userData;
      } else {
        console.error("User not logged in");
        return null;
      }
    } catch (e) {
      console.error("Error getting document: ", e);
      return null;
    }
  }


  return (
    <>
    <Routes>
      <Route path='/' exact element={<Landing />} />
      <Route path='/home' exact element={<Home />} />
      <Route path='/login' exact element={<Login />} />
      <Route path='/signup' exact element={<Signup />} />
      <Route path='/contact' exact element={<Contact />} />
      <Route path='/frontend' exact element={<Frontend saveProgressData={saveFrontendProgressData} getProgressData={handleFrontendProgressData} />} />
      <Route path='/backend' exact element={<Backend saveProgressData={saveBackendProgressData} getProgressData={handleBackendProgressData} />} />
      <Route path='/android' exact element={<Android saveProgressData={saveAndroidProgressData} getProgressData={handleAndroidProgressData} />} />
      <Route path='/ml' exact element={<ML saveProgressData={saveMLProgressData} getProgressData={handleMLProgressData} />} />
      <Route path='/gamedev' exact element={<GameDev saveProgressData={saveGameDevProgressData} getProgressData={handleGameDevProgressData} />} />
      <Route path='/profile' exact element={<Profile getTotalProgressData={handleTotalProgressData}/>} />
    </Routes>
    <GoToTop/>
    <Footer/>
    </>
  );
}

export default App;
